export default __webpack_public_path__ + "static/media/mimi2.5ea5c848.gif";